var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "el-form",
            {
              staticStyle: { "padding-top": "5px" },
              attrs: {
                inline: true,
                disabled: _vm.readonly,
                "label-width": "85px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.OrderNo2") } },
                [
                  _c("el-input", {
                    attrs: { no: "1" },
                    model: {
                      value: _vm.poList.poNo,
                      callback: function($$v) {
                        _vm.$set(_vm.poList, "poNo", $$v)
                      },
                      expression: "poList.poNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ConsignationCompany") } },
                [
                  _c("el-input", {
                    attrs: { no: "2", value: _vm.customerName, disabled: true }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Salesman") } },
                [
                  _c("cargo-user-select", {
                    attrs: {
                      no: "3",
                      disabled: true,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.poList.sales || ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "85px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.SupportSales") } },
                [
                  _c("cargo-user-select", {
                    attrs: {
                      no: "4",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.poList.supportor || ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.OrderCurrency") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "5",
                      filterable: "",
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.poList.poCurrency
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.poList.poCurrency = p.value
                        _vm.poCurrencyCB_changeHandler(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.OrderExchangeRate") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "6",
                      value: _vm.poList.poExchangeRate || 0.0,
                      precision: 6,
                      controls: false
                    },
                    on: {
                      input: function(value) {
                        _vm.poList.poExchangeRate = value || ""
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "85px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.OrderAmount") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "7",
                      precision: 2,
                      value: _vm.poList.poAmount || 0.0,
                      controls: false,
                      disabled: true
                    },
                    on: {
                      input: function(value) {
                        _vm.poList.poAmount = value || ""
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.TheAmountOfWriteOffs") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "8",
                      precision: 2,
                      value: _vm.poList.poDeclareAmount || 0.0,
                      controls: false,
                      disabled: true
                    },
                    on: {
                      input: function(value) {
                        _vm.poList.poDeclareAmount = value || ""
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Difference") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "9",
                      precision: 2,
                      value: _vm.poList.diffAmount || 0.0,
                      controls: false,
                      disabled: true
                    },
                    on: {
                      input: function(value) {
                        _vm.poList.diffAmount = value || ""
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "85px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SeaExport.ServiceFeeDiscountRate") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "10" },
                    model: {
                      value: _vm.poList.commisionDiscount,
                      callback: function($$v) {
                        _vm.$set(_vm.poList, "commisionDiscount", $$v)
                      },
                      expression: "poList.commisionDiscount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.TheFirstBusinessOrNot") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%", "margin-right": "40vw" },
                      attrs: { no: "11" },
                      model: {
                        value: _vm.poList.firstPo,
                        callback: function($$v) {
                          _vm.$set(_vm.poList, "firstPo", $$v)
                        },
                        expression: "poList.firstPo"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$t("SeaExport.No"), value: 0 }
                      }),
                      _c("el-option", {
                        attrs: { label: _vm.$t("SeaExport.Yes"), value: 1 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.FrameContractNumber") } },
                [
                  _c("el-input", {
                    attrs: { no: "12" },
                    model: {
                      value: _vm.poList.faContract,
                      callback: function($$v) {
                        _vm.$set(_vm.poList, "faContract", $$v)
                      },
                      expression: "poList.faContract"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "85px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.OperatingInstructions") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "334px" },
                    attrs: { no: "13", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.poList.opRemarks,
                      callback: function($$v) {
                        _vm.$set(_vm.poList, "opRemarks", $$v)
                      },
                      expression: "poList.opRemarks"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.Remarks") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "334px" },
                    attrs: { no: "14", type: "textarea", rows: 3 },
                    model: {
                      value: _vm.poList.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.poList, "remarks", $$v)
                      },
                      expression: "poList.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "cargo-button-group-slider",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "15",
                      type: "primary",
                      disabled: _vm.readonly
                    },
                    on: {
                      click: function($event) {
                        return _vm.addBtnClickHandler(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "16",
                      type: "primary",
                      disabled: _vm.readonly
                    },
                    on: {
                      click: function($event) {
                        return _vm.addBtnClickHandler(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "17", type: "danger", disabled: _vm.readonly },
                    on: { click: _vm.delBtnClickHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { height: "100%" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.forexPayment,
              "pinned-bottom-row-data": _vm.pinnedBottomRowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "section", staticStyle: { color: "#404144" } }, [
        _c("span", [
          _vm._v(
            " " +
              _vm._s(_vm.total.total) +
              " " +
              _vm._s(_vm.$t("SeaExport.OrderAmount")) +
              ":" +
              _vm._s(_vm.total.orderAmount) +
              " " +
              _vm._s(_vm.$t("SeaExport.PaymentAmount")) +
              ":" +
              _vm._s(_vm.total.paymentAmount) +
              " " +
              _vm._s(_vm.$t("SeaExport.UnpaidAmount")) +
              ":" +
              _vm._s(_vm.total.unpaidAmount) +
              " "
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "420px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            },
            click: _vm.editCancel
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PaymentNo") } },
                    [
                      _c("el-input", {
                        attrs: { no: "18" },
                        model: {
                          value: _vm.oneFormData.paymentNo,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "paymentNo", $$v)
                          },
                          expression: "oneFormData.paymentNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PaymentAmount") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "19", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder("forexAmount")
                          }
                        },
                        model: {
                          value: _vm.oneFormData.forexAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "forexAmount", $$v)
                          },
                          expression: "oneFormData.forexAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ThePrePayment") + "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "20", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder(
                              "paymentPreLocalAmount"
                            )
                          }
                        },
                        model: {
                          value: _vm.oneFormData.paymentPreLocalAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.oneFormData,
                              "paymentPreLocalAmount",
                              $$v
                            )
                          },
                          expression: "oneFormData.paymentPreLocalAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Currency") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "21", disabled: true },
                        model: {
                          value: _vm.oneFormData.forexCurrency,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "forexCurrency", $$v)
                          },
                          expression: "oneFormData.forexCurrency"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.PaymentExchangeRate") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "22", precision: 6, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder(
                              "forexExchangeRate"
                            )
                          }
                        },
                        model: {
                          value: _vm.oneFormData.forexExchangeRate,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "forexExchangeRate", $$v)
                          },
                          expression: "oneFormData.forexExchangeRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ActualPaymentAmount") + "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: {
                          no: "23",
                          precision: 2,
                          controls: false,
                          placeholder: _vm.$t(
                            "SeaExport.RoundPaymentAmountExchangeRate"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.numberFormat(
                              _vm.oneFormData.actualPaymentAmount
                            )
                          }
                        },
                        model: {
                          value: _vm.oneFormData.actualPaymentAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.oneFormData,
                              "actualPaymentAmount",
                              $$v
                            )
                          },
                          expression: "oneFormData.actualPaymentAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ServiceCharge") + "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "24", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder("commission")
                          }
                        },
                        model: {
                          value: _vm.oneFormData.commission,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "commission", $$v)
                          },
                          expression: "oneFormData.commission"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.PostalCharges") + "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "25", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder(
                              "postalCommission"
                            )
                          }
                        },
                        model: {
                          value: _vm.oneFormData.postalCommission,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "postalCommission", $$v)
                          },
                          expression: "oneFormData.postalCommission"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.AcceptanceFee") + "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: { no: "26", precision: 2, controls: false },
                        on: {
                          change: function($event) {
                            return _vm.forexPaymentChangedHanlder(
                              "acceptCommission"
                            )
                          }
                        },
                        model: {
                          value: _vm.oneFormData.acceptCommission,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "acceptCommission", $$v)
                          },
                          expression: "oneFormData.acceptCommission"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("SeaExport.RetreatMoreFillLessAmount") +
                          "(RMB)"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "190px" },
                        attrs: {
                          no: "27",
                          precision: 2,
                          controls: false,
                          disabled: true,
                          placeholder: _vm.$t(
                            "SeaExport.AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.numberFormat(_vm.oneFormData.diffAmount)
                          }
                        },
                        model: {
                          value: _vm.oneFormData.diffAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "diffAmount", $$v)
                          },
                          expression: "oneFormData.diffAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PaymentDate") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "28",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.oneFormData.paymentDate,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "paymentDate", $$v)
                          },
                          expression: "oneFormData.paymentDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "29", type: "primary" },
                  on: { click: _vm.confirmAdd }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "30" }, on: { click: _vm.editCancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }